<div class="detail-header px-l0 px-base-md-u8 py-base-l0 py-base-md-l4">
  <div class="d-grid gap-5">
    <div class="col-auto d-flex align-items-start">
      <svg class="icon-back text-gray-pantone pointer"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
        width="20"
        height="20"
        (click)="goBack()">
        <use href="assets/images/icons/arrows/arrow-left.svg#arrow-left"></use>
      </svg>
    </div>
    <div class="col d-flex align-items-center">
      <h4 class="ms-l8">{{ title | translate }}</h4>
    </div>
  </div>
</div>
